import {RouterModule, Routes} from '@angular/router';

import {NgModule} from '@angular/core';
import {NewLoginPageAdapterComponent} from './standelones/new-login-page-adapter/new-login-page-adapter.component';

const routes: Routes = [
    // { path: 'login', component: LoginComponent, data: { title: '' } },
    {
        path: 'auth',
        component: NewLoginPageAdapterComponent,

        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
    },
    {path: 'login', redirectTo: 'auth/login', pathMatch: 'full'},
    {path: 'settings', redirectTo: 'auth/settings', pathMatch: 'full'},


];

@NgModule({
    imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload', enableTracing: false})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
